import { useNavigateToLink } from "../hooks/useNavigateToLink";

type LinkProps = {
  href: string;
  className?: string;
  children: React.ReactNode;
  external?: boolean;
};

export default function Link({
  href,
  className,
  children,
  external,
}: LinkProps) {
  const handleNavClick = useNavigateToLink();

  return (
    <a
      href={href}
      onClick={external ? undefined : (e) => handleNavClick(e, href)}
      className={className}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener" : undefined}
    >
      {children}
    </a>
  );
}
